import React from 'react';
import { Section } from './ui/Section';
import { Server, Shield, Code, Network, Lock, Cpu } from 'lucide-react';
const topics = [{
  icon: <Code className="h-8 w-8 text-blue-600" data-id="element-137" />,
  title: 'Web Scraping Methodologies',
  description: 'Learn how to build web scrapers using headless browsers, handle anti-bot systems, and parse data efficiently. We cover both the technical setup and legal considerations.'
}, {
  icon: <Network className="h-8 w-8 text-indigo-600" data-id="element-138" />,
  title: 'Proxy & Network Architecture',
  description: 'Guides on setting up proxy networks, choosing between residential and datacenter proxies, and routing requests reliably at scale.'
}, {
  icon: <Shield className="h-8 w-8 text-emerald-600" data-id="element-139" />,
  title: 'Digital Security',
  description: 'Security protocols explained clearly. We cover vulnerability testing, defensive strategies, and how to protect your data infrastructure from common threats.'
}, {
  icon: <Server className="h-8 w-8 text-violet-600" data-id="element-140" />,
  title: 'Data Infrastructure',
  description: 'Build data pipelines that can handle large volumes. Articles on storage systems, processing frameworks, and scaling your infrastructure as you grow.'
}, {
  icon: <Lock className="h-8 w-8 text-rose-600" data-id="element-141" />,
  title: 'Privacy & Compliance',
  description: 'Practical guides on GDPR and CCPA compliance. Learn what data you can collect, how to handle user privacy, and how to stay on the right side of the law.'
}, {
  icon: <Cpu className="h-8 w-8 text-amber-600" data-id="element-142" />,
  title: 'Emerging Technologies',
  description: 'New tools and techniques in data analysis and security. We write about AI applications, machine learning for security, and other technologies worth paying attention to.'
}];
export function Topics() {
  return <Section id="topics" background="gray" data-id="element-143">
      <div className="text-center max-w-3xl mx-auto mb-16" data-id="element-144">
        <h2 className="text-3xl md:text-4xl font-bold text-slate-900 mb-4" data-id="element-145">
          What We Write About
        </h2>
        <p className="text-lg text-slate-600" data-id="element-146">
          <a href="https://dataprixa.com" className="text-blue-600 hover:underline font-medium" data-id="element-147">
            Dataprixa
          </a>{' '}
          covers data collection, infrastructure design, and security. Here are
          the main topics we focus on.
        </p>
      </div>

      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8" data-id="element-148">
        {topics.map((topic, index) => <div key={index} className="bg-white p-8 rounded-xl shadow-sm hover:shadow-md transition-shadow duration-300 border border-slate-100" data-id="element-149">
            <div className="mb-6 p-3 bg-slate-50 rounded-lg inline-block" data-id="element-150">
              {topic.icon}
            </div>
            <h3 className="text-xl font-bold text-slate-900 mb-3" data-id="element-151">
              {topic.title}
            </h3>
            <p className="text-slate-600 leading-relaxed" data-id="element-152">
              {topic.description}
            </p>
          </div>)}
      </div>
    </Section>;
}